/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCurrentUserPylonPendingMessage200ResponseData } from './GetCurrentUserPylonPendingMessage200ResponseData';
import {
    GetCurrentUserPylonPendingMessage200ResponseDataFromJSON,
    GetCurrentUserPylonPendingMessage200ResponseDataFromJSONTyped,
    GetCurrentUserPylonPendingMessage200ResponseDataToJSON,
    GetCurrentUserPylonPendingMessage200ResponseDataToJSONTyped,
} from './GetCurrentUserPylonPendingMessage200ResponseData';

/**
 * 
 * @export
 * @interface GetCurrentUserPylonPendingMessage200Response
 */
export interface GetCurrentUserPylonPendingMessage200Response {
    /**
     * 
     */
    data: GetCurrentUserPylonPendingMessage200ResponseData;
}

/**
 * Check if a given object implements the GetCurrentUserPylonPendingMessage200Response interface.
 */
export function instanceOfGetCurrentUserPylonPendingMessage200Response(value: object): value is GetCurrentUserPylonPendingMessage200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetCurrentUserPylonPendingMessage200ResponseFromJSON(json: any): GetCurrentUserPylonPendingMessage200Response {
    return GetCurrentUserPylonPendingMessage200ResponseFromJSONTyped(json, false);
}

export function GetCurrentUserPylonPendingMessage200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentUserPylonPendingMessage200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': GetCurrentUserPylonPendingMessage200ResponseDataFromJSON(json['data']),
    };
}

export function GetCurrentUserPylonPendingMessage200ResponseToJSON(json: any): GetCurrentUserPylonPendingMessage200Response {
    return GetCurrentUserPylonPendingMessage200ResponseToJSONTyped(json, false);
}

export function GetCurrentUserPylonPendingMessage200ResponseToJSONTyped(value?: GetCurrentUserPylonPendingMessage200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GetCurrentUserPylonPendingMessage200ResponseDataToJSON(value['data']),
    };
}

